export default __webpack_public_path__ + "static/media/mastercard.b720e3b5.svg";